//import { render } from '@testing-library/react';
import React from 'react';
import { render } from 'react-dom';
const entries = [<li>use your old batteries to make a powerwall</li>,
<li>you can use your old batteries to store energy from solar panels</li>,
<li>use your old batteries to make a hovercraft</li>];
function insert1() {

    var c = document.getElementById("idea").value;
    entries.push(<li>{c}</li>);
    document.getElementById("idea").value = "";

    const root = document.querySelector("#unc")

    render(entries, root);


}

function Recycle() {
    return (
        <html lang="en">

            <head>


            </head>

            <body style={{ textAlign: "center" }}>
                welcome to the recycling  page
            </body>
            <div style={{ textAlign: "center" }}>
                <p>Feel free to add new tips and ideas for recycling EV  batteries
                    <br />Also feel free to just browse for cool ideas and projects <br />
                    For those looking to safely dispose of batteries we will also include some locations you can go to</p>
            </div>


            <h2 style={{ textAlign: "center" }}>Cool recycling ideas <input placeholder="share an idea" type="text" name="idea" id="idea"></input> <button onClick={insert1}>Add</button></h2>
            <ol id="unc" style={{ border: "1px solid black" }}>
                {entries}

            </ol>
            <h2 style={{ textAlign: "center" }}>Dealerships</h2>


        </html>
    );
}

export default Recycle;